import contentfulGql from 'js/lib/contentfulGql';

import { entWebsiteBlockAssemblyFragment } from 'bundles/ent-website/queries/EntWebsiteBlockAssembly';
import { entWebsiteHowFragment } from 'bundles/ent-website/queries/EntWebsiteHow';

export const entWebsiteContentFragment = contentfulGql`#graphql
  ${entWebsiteHowFragment}
  fragment EntWebsiteContent on EntWebsiteContent {
    headline
    slug
    description
    tabNames
    howsCollection(limit: 10) {
      items {
        ...EntWebsiteHow
     }
    }
  }
`;

export const entWebsiteBlockContentQuery = contentfulGql`#graphql
  ${entWebsiteBlockAssemblyFragment}
  ${entWebsiteContentFragment}
  query entWebsiteBlockContent($id: String!, $preview: Boolean, $locale: String!) {
    entWebsiteBlockAssembly(id: $id, preview: $preview, locale: $locale) {
      ...EntWebsiteBlockAssembly
      reference {
        __typename
        ...EntWebsiteContent
      }
    }
  }
`;
